// extracted by mini-css-extract-plugin
export var actionText = "_os-4";
export var container = "_os-0";
export var leftSection = "_os-1";
export var rightSection = "_os-2";
export var settingsButton = "_os-6";
export var settingsIcon = "_os-7";
export var shortcut = "_os-5";
export var shortcutGroup = "_os-3";